<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: true
    },

    uploading: {
      type: Boolean,
      default: undefined
    }
  },

  methods: {
    handleInputChange(e) {
      const files = Array.from(e.target.files)

      e.target.value = ''

      if (files.length === 0) {
        this.$emit('change', null)
        return
      }

      this.$emit('change', this.multiple ? files : files[0])
    }
  },

  render() {
    return (
      <div class={this.$style.root}>
        <i
          class={[
            this.uploading ? 'el-icon-loading' : 'el-icon-upload',
            this.$style.icon
          ]}
        ></i>
        <input
          type="file"
          multiple={this.multiple}
          accept="image/*,application/pdf"
          disabled={this.uploading}
          class={this.$style.input}
          onChange={this.handleInputChange}
        />
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.root {
  border: $--border-width-base dashed $--border-color-base;
  border-radius: $--border-radius-base;
  color: $--border-color-base;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  position: relative;
  transition: all 0.25s ease-out;
  user-select: none;

  &:hover {
    border-color: $--border-color-hover;
    color: $--border-color-hover;
  }
}

.input {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  opacity: 0;
  cursor: pointer;

  &[disabled] {
    pointer-events: none;
  }
}

.icon {
  font-size: 3rem;
}
</style>
